@let lp = loadedProduct();
@if (lp) {
  <div class="row gy-3" >
    @for (attribute of lp.selectableAttributes | keyvalue; track attribute) {
      @if (attribute.value.options.length > 1 || isSwatchOption(attribute.value)) {
        <div class="col-12" [class.invalid]="validating">
          <div class="attribute-selector {{ attribute.value.code }}" [class.error]="! isAttributeValid(attribute.value.code)">
            <h4 aria-level="2">{{ attribute.value.title }}</h4>
            @for (option of attribute.value.options; track option) {
              @if (option.imageSlug || !isSwatchOption(attribute.value)) {
                @if (!option.imageSlug || isSelectionInStockOrReminder(attribute.value.code, option)) {
                  <!-- swatch -->
                  @if (option.imageSlug) {
                    <span
                      class="swatch-color bold"
                      ngbTooltip="{{ option.title }}" placement="bottom-left"
                      [triggers]="screenService.currentDimensionIsSmallerThan('sm') ? 'manual' : 'hover focus'" #t="ngbTooltip" (click)="t.open()"
                      [class.disabled]="!isSelectionPossible(attribute.value.code, option) || !isSelectionInStockOrReminder(attribute.value.code, option)"
                      [attr.aria-disabled]="(!isSelectionPossible(attribute.value.code, option) || !isSelectionInStockOrReminder(attribute.value.code, option)) ? 'true' : null"
                      [class.selected]="isSelected(attribute.value.code, option)"
                      (click)="toggleActiveSelection(attribute.value.code, option)"
                      >
                      <img
                        [ngSrc]="option.imageSlug"
                        [attr.alt]="getTooltip(attribute.value, option)"
                        class="img-fluid img-round"
                        ngSrcset="18w, 32w"
                        width="30"
                        height="30"
                        />
                    </span>
                  } @else {
                    <div [ngbTooltip]="getTooltip(attribute.value, option)" placement="bottom-left"
                      [class.disabled]="!isSelectionPossible(attribute.value.code, option) || !isSelectionInStockOrReminder(attribute.value.code, option)"
                      [attr.aria-disabled]="(!isSelectionPossible(attribute.value.code, option) || !isSelectionInStockOrReminder(attribute.value.code, option)) ? 'true' : null"
                      [class.selected]="isSelected(attribute.value.code, option)"
                      (click)="toggleActiveSelection(attribute.value.code, option)"
                      class="tile">
                      {{ option.title }}{{ attribute.value.unit ? (' ' + attribute.value.unit) : '' }}
                    </div>
                  }
                  <!-- no-swatch -->
                }
              }
            }
          </div>
        </div>
      }
    }
  </div>
}
